import { AxiosResponseHeaders, RawAxiosResponseHeaders } from 'axios';

export const getFileName = (
    headers: RawAxiosResponseHeaders | AxiosResponseHeaders,
) => {
    return headers['content-disposition']
        ?.split(';')
        .find((x) => x.includes('filename='))
        ?.replace('filename=', '')
        .trimStart();
};

export const downloadBlob = (
    data: any,
    headers: RawAxiosResponseHeaders | AxiosResponseHeaders,
    fileExtension?: string,
) => {
    const href = URL.createObjectURL(data);

    // create "a" HTML element with href to file & click. Get Filename from content-disposition header.
    const link = document.createElement('a');
    link.href = href;
    let fileName = getFileName(headers);

    if (fileExtension) {
        fileName = fileName.replace('.zip', '') + fileExtension; // TODO: We probably should replace any extension with this
    }
    link.setAttribute('download', fileName as any); // or any other extension
    document.body.appendChild(link);
    link.click();

    // clean up "a" element & remove ObjectURL
    document.body.removeChild(link);
    URL.revokeObjectURL(href);
};
